import { render, staticRenderFns } from "./UpgradePlan.vue?vue&type=template&id=5c7cd86b&scoped=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlan.vue?vue&type=style&index=0&id=5c7cd86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7cd86b",
  null
  
)

export default component.exports